"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Query = void 0;
class Query {
    constructor(config) {
        this.config = config;
    }
    new(...a) {
        throw new Error("Typecast Query object to the appropriate version to use this method. Example:\n\n" +
            "const axiom = new AxiomSdkCore(config)\n" +
            "const aq = axiom.query as QueryV2;\n" +
            "const query = aq.new();");
    }
}
exports.Query = Query;
//# sourceMappingURL=query.js.map